import { api, helpers, ts } from '_core';

type BacktestSetApiResponse = {
  data: ts.types.backtestSet.BacktestSet;
};

export const createBacktestSet = async (
  newData: ts.types.backtestSet.BacktestSetDraft,
  callback: (_data: ts.types.backtestSet.BacktestSet) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: BacktestSetApiResponse = await api.backtest_sets.create({
      ...newData,
      skip_signature_check: true,
    });
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error creating backtest set - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateBacktestSet = async (
  id: number,
  newData: ts.types.backtestSet.BacktestSetDraft,
  callback: (_data: ts.types.backtestSet.BacktestSet) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp: BacktestSetApiResponse = await api.backtest_sets.update(id, { ...newData });
    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating backtest set - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};

export const updateDefinition = async (
  backtestSet: ts.types.backtestSet.BacktestSet,
  definition: ts.types.backtestSet.DefinitionDraft,
  isValid: boolean,
  callback: (_data: ts.types.backtestSet.BacktestSet) => void,
  errorCallback: (_error: string) => void
) => {
  try {
    const resp = await api.backtest_sets.update(
      backtestSet.id,
      {
        definition,
        ui_metadata: { ...backtestSet.ui_metadata },
        is_valid: isValid,
        skip_signature_check: !isValid,
      },
      true
    );

    callback(resp.data);
  } catch (error) {
    errorCallback(`Error updating the definition - ${helpers.parseApiError(error as ts.types.common.ApiError)}`);
  }
};
